// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__ejmlD","bigColWidth":"Table_bigColWidth___wqVc","biggerColWidth":"Table_biggerColWidth__2DsR7","row":"Table_row__V7MlE","col":"Table_col__333xx"};